jQuery(function initTabControls($) {

    $('.js-tab-container').each(function() {

        var $container = $(this);

        $container.on('click', '.js-tab-control', function(event) {

            var $tabControl           = $(this);
            var $tabControlsContainer = $container.find('.js-tab-controls');
            var $controls             = $tabControlsContainer.find('.js-tab-control');
            var $contents             = $container.find('.js-tab-content');
            var isCurrent             = $tabControl.hasClass('current');

            // As long as your DOM order is check, you can have two or more control
            // sets for a single content set. Useful for mobile-specific controls.
            var isMultiControls = $controls.length > $contents.length;
            var selectedContentIndex;
            var $assocControls;

            if (isMultiControls) {

                selectedContentIndex = $controls.index(this) % $contents.length;

                $assocControls = $($.grep($controls.toArray(), function(el, index) {

                    return index % $contents.length === selectedContentIndex;
                }));
            }
            else {

                selectedContentIndex = $controls.index(this);
                $assocControls       = $tabControl;
            }

            if (isCurrent) return;

            $controls.removeClass('current').index(this);

            $assocControls.addClass('current');

            var $associatedTabControlsDropdown = $tabControlsContainer.siblings('.js-tab-controls-dropdown');

            if ($associatedTabControlsDropdown.length) {

                var $tabControlsDropdownSelectOptions = $associatedTabControlsDropdown.find('.js-custom-select-option');
                $tabControlsDropdownSelectOptions.removeClass('selected');

                var $tabControlTwinDropdownOption = $tabControlsDropdownSelectOptions.eq(selectedContentIndex);
                $tabControlTwinDropdownOption.addClass('selected');
                $associatedTabControlsDropdown.find('.js-btn-custom-label').text($tabControlTwinDropdownOption.text());
            }

            $($contents.hide().get(selectedContentIndex)).show();

            var scrollTarget = $tabControl.attr('data-tab-scroll-target');

            if (scrollTarget) {

                var $scrollTarget = $('[data-tab-content-id="' + scrollTarget + '"]');

                if ($scrollTarget.length) {

                    var containerY        = $container.offset().top;
                    var targetY           = $scrollTarget.offset().top;
                    var $win              = $(window);
                    var winScrollTop      = $win.scrollTop();
                    var viewportHeight    = $win.innerHeight();
                    var tabScrollOffset   = parseInt($scrollTarget.attr('data-tab-scroll-offset'),10);
                    var finalScrollOffset = containerY - targetY + tabScrollOffset;

                    if (!(targetY > winScrollTop && targetY < winScrollTop + viewportHeight)) {

                        // Not in view, so scroll
                        $('html, body').animate({scrollTop: (targetY + finalScrollOffset) + 'px'});
                    }
                }
            }

        });

        $container.on('click', '.js-tab-controls-dropdown .js-button-control', function(event) {

            event.stopPropagation();

            var $buttonControl = $(this);

            if ($buttonControl.hasClass('current')) {

                $buttonControl.removeClass('current');
            }
            else {

                $buttonControl.addClass('current');
            }
        });

        $container.on('click', '.js-tab-controls-dropdown .js-custom-select-option', function(event) {

            event.stopPropagation();

            var $selectedOption      = $(this);
            var $tabControlsDropdown = $selectedOption.closest('.js-tab-controls-dropdown');

            var $buttonControl       = $selectedOption.parents('.js-button-control');
            var previousSelection    = $buttonControl.data('current-selection');

            // $buttonControl.find('.js-btn-custom-label').text($selectedOption.text());
            $buttonControl.removeClass('current');

            var currentSelection = $selectedOption.data('tab-scroll-target');

            if (currentSelection !== previousSelection) {

                $buttonControl.data('current-selection', currentSelection);

                var $associatedTabControls = $tabControlsDropdown.siblings('.js-tab-controls');
                $tabControlTwin            = $associatedTabControls.find('.js-tab-control[data-tab-scroll-target=' + currentSelection + ']');
                $tabControlTwin.trigger('click');
            }
        });
    });

    $('html').click(function(event) {

        var $buttonControl = $('.js-tab-controls-dropdown .js-custom-button .js-button-control');

        if ($buttonControl.hasClass('current')) {

            $buttonControl.removeClass('current');
        }
    });
});